/**
 * The `user.id` dataLayer key path, spelled in exactly one place.
 *
 * Two callers sit on opposite sides of the server/client boundary — the SSR
 * inline script that seeds the identity during document parse, and the client
 * hook's keyless identify push — so this module must stay neutral: no
 * `@next/third-parties/google` (`sendGTMEvent` is client-only and would poison
 * the server graph), no `'use client'`, no browser globals. The shape lives
 * here; each caller owns its transport.
 */
export const buildGtmIdentityPush = (userId: string): { user: { id: string } } => ({
  user: { id: userId },
})
